import React from "react";

export default function Footer(props) {
  return (
    <div className="footer">
      <div className="dataSource">
        <p>
          Atmospheric Data: <br />
          NASA MERRA-2 Dataset (2018-2021)
        </p>
        <div />
        <div className="citation">
          <p>
            <b> Spectral Modeling:</b>
            <br />
            <a href="https://www.jstor.org/stable/26182461">
              Simple Solar Spectral Model for Direct and Diffuse <br />
              Irradiance on Horizontal and Tilted Planes at the Earth's Surface
              for Cloudless Atmospheres, NREL Technical Report (Bird and
              Riordan, 1985)
            </a>
          </p>
        </div>
        <div className="credits">
          <p>
            Developed by: <br />
            Leila Alhemali Ayad, Robin Chartrand <br /> and Lauren Brownlee for
            UbiQD Inc. 2022
          </p>
        </div>
      </div>
    </div>
  );
}
